import { Modal } from "antd"
import { useSelector } from "react-redux"

import ChangeInvoiceAmountForm from "../../../../Components/Forms/ChangeInvoiceAmountForm"

export const ChangeAmountModal = ({
  setModalType,
  modalType,
  fetching,
  handleConfirmUpdatedAmount
}) => {
  const isMobile = useSelector((state) => state.nav.isMobile)

  const handleCloseModal = () => {
    setModalType(false)
  }

  const handleSubmitForm = ({ current_invoice_amount, ...newData }) => {
    console.log(newData)
    handleConfirmUpdatedAmount({ id: modalType?.invoice_id, ...newData })
  }

  return (
    <Modal
      open={true}
      centered={!isMobile}
      width={410}
      title={"Change the invoice amount"}
      footer={null}
      closable="true"
      onCancel={handleCloseModal}
      destroyOnClose
      classNames={{ content: "clear-bg" }}
      getContainer={() => document.getElementById("global-wrap")}
    >
      <ChangeInvoiceAmountForm
        initialValues={{ current_invoice_amount: modalType?.invoice_amount }}
        onClose={handleCloseModal}
        onSubmit={handleSubmitForm}
        isSubmitting={fetching}
      />
    </Modal>
  )
}
